export default __webpack_public_path__ + "static/media/triangle-arrow-down.ee17a55a.svg";